import axios from 'axios';

const API = axios.create({
  baseURL: process.env.DEVELOPMENT == 'true' ? process.env.URL_DEVELOPMENT : process.env.URL,
  headers: { "Content-Type" : "application/json" }
});

export default API ;